/* src/app/admin/user-role/user-role.component.scss */
/*# sourceMappingURL=user-role.component-P3KVZU27.css.map */
